import { Component } from '@angular/core';

@Component({
  selector: 'app-property-division-stage-pf',
  templateUrl: './property-division-stage-pf.component.html',
  styleUrls: ['./property-division-stage-pf.component.scss'],
})
export class PropertyDivisionStagePfComponent {
  constructor() {}
}
